import React from 'react';
import Wrapper from './components/Wrapper';

export default function Index(props) {
	/* eslint-disable no-unused-vars */

	React.useEffect(() => {});

	return (
		<div className="home">
			<Wrapper />
		</div>
	);
}
